// Mobile Navigation Accordion JavaScript
(function () {
  "use strict";

  console.log("Mobile accordion script loaded");

  // Initialize accordion functionality
  function initMobileAccordion() {
    console.log("Initializing mobile accordion...");
    const accordionHeaders = document.querySelectorAll(
      ".mobile-accordion-header"
    );
    console.log("Found accordion headers:", accordionHeaders.length);

    accordionHeaders.forEach((header, index) => {
      console.log("Setting up header", index, header);

      // Remove existing listeners to prevent duplicates
      header.removeEventListener("click", handleAccordionClick);
      header.addEventListener("click", handleAccordionClick);
    });
  }

  function handleAccordionClick(e) {
    e.preventDefault();
    e.stopPropagation();

    console.log("Accordion clicked:", this);

    const content = this.nextElementSibling;
    const isActive = this.classList.contains("active");

    console.log("Content element:", content);
    console.log("Is active:", isActive);

    // Toggle current accordion only (don't close others)
    if (isActive) {
      this.classList.remove("active");
      if (content) content.classList.remove("active");
    } else {
      this.classList.add("active");
      if (content) content.classList.add("active");
    }

    console.log("Accordion toggled. Active:", !isActive);
  }

  // Initialize when DOM is ready
  function init() {
    console.log("DOM ready, initializing...");
    initMobileAccordion();

    // Also listen for clicks on the mobile nav toggle to reinitialize
    document.addEventListener("click", function (e) {
      if (e.target.closest(".mobile-nav-toggle")) {
        console.log("Mobile nav toggle clicked, will reinitialize...");
        setTimeout(initMobileAccordion, 500);
      }
    });
  }

  // Wait for DOM
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Also observe for dynamically added content
  const observer = new MutationObserver(function (mutations) {
    let shouldReinit = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasAccordion = addedNodes.some(
          (node) =>
            node.nodeType === 1 &&
            (node.classList?.contains("mobile-accordion-nav") ||
              node.querySelector?.(".mobile-accordion-nav"))
        );

        if (hasAccordion) {
          shouldReinit = true;
        }
      }
    });

    if (shouldReinit) {
      console.log("Accordion content added, reinitializing...");
      setTimeout(initMobileAccordion, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
(function () {
  "use strict";

  const TARGET_PARENT = "collections"; // match text

  function normalizeText(el) {
    return (el?.textContent || "").trim().toLowerCase();
  }

  function forceOpenHeader(header) {
    if (!header) return;
    const content = header.nextElementSibling;
    header.classList.add("active");
    if (content) content.classList.add("active");
  }

  function forceOpenShapewearSubcategories() {
    // Find all accordion headers (top-level + nested)
    const headers = document.querySelectorAll(".mobile-accordion-header");
    if (!headers.length) return;

    // 1) Find the "ALL SHAPEWEAR" header
    let shapewearHeader = null;
    headers.forEach((h) => {
      if (normalizeText(h) === TARGET_PARENT) shapewearHeader = h;
    });
    if (!shapewearHeader) return;

    // 2) Force open "ALL SHAPEWEAR"
    forceOpenHeader(shapewearHeader);

    // 3) Force open all subcategory accordions inside its panel
    const shapewearPanel = shapewearHeader.nextElementSibling;
    if (!shapewearPanel) return;

    const nestedHeaders = shapewearPanel.querySelectorAll(".mobile-accordion-header");
    nestedHeaders.forEach((h) => forceOpenHeader(h));
  }

  // Run now + after drawer open + after DOM changes
  function initForceOpen() {
    forceOpenShapewearSubcategories();
    // run again shortly because themes often animate/replace nodes
    setTimeout(forceOpenShapewearSubcategories, 150);
    setTimeout(forceOpenShapewearSubcategories, 600);
  }

  // DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initForceOpen);
  } else {
    initForceOpen();
  }

  // When hamburger toggled, re-apply
  document.addEventListener("click", function (e) {
    if (e.target.closest(".mobile-nav-toggle")) {
      setTimeout(initForceOpen, 200);
    }
  });

  // Observe DOM changes (theme re-renders nav — only reinit when accordion nav itself is added)
  const observer = new MutationObserver(function (mutations) {
    const hasAccordionNav = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (node) {
        return node.nodeType === 1 &&
          (node.classList?.contains('mobile-accordion-nav') ||
            node.querySelector?.('.mobile-accordion-nav'));
      });
    });
    if (hasAccordionNav) initForceOpen();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
